// DJ Escapamentos — theme JS (Shopify Ajax Cart + Drawer + Mobile Menu)
(function() {
  'use strict';

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  const $ = (s, c) => (c || document).querySelector(s);
  const $$ = (s, c) => Array.from((c || document).querySelectorAll(s));
  const fmt = (cents) => 'R$ ' + (cents / 100).toFixed(2).replace('.', ',');

  // ============ CART API ============
  async function getCart() {
    const r = await fetch(root + 'cart.js', { credentials: 'same-origin' });
    return r.json();
  }

  async function addToCart(variantId, qty) {
    qty = qty || 1;
    const r = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ items: [{ id: parseInt(variantId, 10), quantity: qty }] })
    });
    if (!r.ok) {
      const err = await r.json().catch(() => ({}));
      throw new Error(err.description || 'Falha ao adicionar ao carrinho');
    }
    return r.json();
  }

  async function changeCartItem(key, qty) {
    const r = await fetch(root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    });
    return r.json();
  }

  // ============ DRAWER ============
  function openCart() {
    document.body.classList.add('cart-open');
    $('#cartOverlay') && $('#cartOverlay').classList.add('open');
    $('#cartDrawer') && $('#cartDrawer').classList.add('open');
    refreshCartUI();
  }
  function closeCart() {
    document.body.classList.remove('cart-open');
    $('#cartOverlay') && $('#cartOverlay').classList.remove('open');
    $('#cartDrawer') && $('#cartDrawer').classList.remove('open');
  }
  window.toggleCart = function() {
    document.body.classList.contains('cart-open') ? closeCart() : openCart();
  };
  window.closeCart = closeCart;

  // ============ MOBILE MENU ============
  window.openMobileMenu = function() {
    $('#mobileMenu') && $('#mobileMenu').classList.add('open');
  };
  window.closeMobileMenu = function() {
    $('#mobileMenu') && $('#mobileMenu').classList.remove('open');
  };

  // ============ HEADER SCROLL STATE ============
  function updateScrolled() {
    if (window.scrollY > 8) {
      document.body.setAttribute('data-scrolled', 'true');
    } else {
      document.body.removeAttribute('data-scrolled');
    }
  }
  window.addEventListener('scroll', updateScrolled, { passive: true });
  updateScrolled();

  // ============ ESC CLOSES OVERLAYS ============
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') {
      closeCart();
      window.closeMobileMenu();
      const fd = $('#filterDrawer');
      if (fd) fd.classList.remove('open');
    }
  });

  // ============ RENDER CART ============
  async function refreshCartUI() {
    let cart;
    try { cart = await getCart(); } catch (e) { return; }

    // Header badges
    $$('.cart-count-bubble, #hCartBadge, #bCartBadge').forEach(el => {
      el.textContent = cart.item_count;
      el.style.display = cart.item_count > 0 ? '' : 'none';
    });
    $('#cartCount') && ($('#cartCount').textContent = cart.item_count + (cart.item_count === 1 ? ' item' : ' itens'));

    // Body
    const body = $('#cartBody');
    if (!body) return;
    if (cart.items.length === 0) {
      body.innerHTML = '<div style="text-align:center; padding:40px 0;">' +
        '<div style="font-family:\'Anton\',\'Inter\',sans-serif; font-size:26px; text-transform:uppercase; letter-spacing:0.02em; margin-bottom:10px;">Seu carrinho está <span style="color:var(--brand);">vazio</span></div>' +
        '<div style="font-size:13px; color:var(--text-2); margin-bottom:24px;">Que tal começar pelos catalisadores?</div>' +
        '<a class="btn primary" href="/collections/catalisadores" onclick="closeCart()">Ver catálogo</a>' +
        '</div>';
      $('#cartSubtotal') && ($('#cartSubtotal').textContent = fmt(0));
      $('#cartTotal') && ($('#cartTotal').textContent = fmt(0));
      const shipping = $('#cartShipping');
      if (shipping) { shipping.textContent = 'A calcular'; shipping.className = ''; }
      return;
    }

    body.innerHTML = cart.items.map(function(item) {
      const img = item.featured_image && item.featured_image.url
        ? '<img src="' + item.featured_image.url + '&width=128" class="cart-line-img" alt="" loading="lazy">'
        : '<div class="cart-line-img"></div>';
      return '<div class="cart-line">' +
        '<a href="' + item.url + '" class="cart-line-img-wrap" onclick="closeCart()">' + img + '</a>' +
        '<div class="cart-line-info">' +
          '<div class="cart-line-top">' +
            '<div>' +
              '<div class="cart-line-brand">' + (item.vendor || '') + '</div>' +
              '<a href="' + item.url + '" onclick="closeCart()" style="display:block; color:inherit; text-decoration:none;">' +
                '<div class="cart-line-name">' + item.product_title + '</div>' +
              '</a>' +
              (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line-meta">' + item.variant_title + '</div>' : '') +
            '</div>' +
            '<button class="cart-line-remove" data-key="' + item.key + '" aria-label="Remover">' +
              '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M3 6h18"/><path d="M8 6V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"/><path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6"/><line x1="10" y1="11" x2="10" y2="17"/><line x1="14" y1="11" x2="14" y2="17"/></svg>' +
            '</button>' +
          '</div>' +
          '<div class="cart-line-bot">' +
            '<div class="qty">' +
              '<button data-key="' + item.key + '" data-delta="-1">−</button>' +
              '<span class="v">' + item.quantity + '</span>' +
              '<button data-key="' + item.key + '" data-delta="1">+</button>' +
            '</div>' +
            '<div class="cart-line-price">' + fmt(item.final_line_price) + '</div>' +
          '</div>' +
        '</div>' +
      '</div>';
    }).join('');

    // Subtotal/total
    $('#cartSubtotal') && ($('#cartSubtotal').textContent = fmt(cart.items_subtotal_price));

    /* Frete: quem estampa o status e o cart-shipping.js, com base nas cotacoes
       reais por CEP; aqui so invalida cotacao antiga quando o carrinho muda */
    const ship = $('#cartShipping');
    if (ship) { ship.textContent = 'A calcular'; ship.className = ''; }

    $('#cartTotal') && ($('#cartTotal').textContent = fmt(cart.total_price));
  }

  // ============ EVENT DELEGATION ============
  document.addEventListener('click', async function(e) {
    // PLP/Home card "Adicionar"
    const addBtn = e.target.closest('[data-pcard-add]');
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();
      const variantId = addBtn.getAttribute('data-variant-id');
      if (!variantId) return;
      addBtn.disabled = true;
      const span = addBtn.querySelector('span');
      const original = span ? span.textContent : '';
      if (span) span.textContent = 'Adicionando...';
      try {
        await addToCart(variantId, 1);
        openCart();
        if (span) span.textContent = 'Adicionado!';
        setTimeout(() => { if (span) span.textContent = original; }, 1200);
      } catch (err) {
        alert(err.message || 'Erro ao adicionar');
        if (span) span.textContent = original;
      } finally {
        addBtn.disabled = false;
      }
      return;
    }
    // Qty +/-
    const qBtn = e.target.closest('.qty button[data-key]');
    if (qBtn) {
      const key = qBtn.dataset.key;
      const delta = parseInt(qBtn.dataset.delta, 10);
      const current = parseInt(qBtn.parentElement.querySelector('.v').textContent, 10);
      const newQty = Math.max(0, current + delta);
      qBtn.disabled = true;
      try { await changeCartItem(key, newQty); await refreshCartUI(); } catch (err) {}
      qBtn.disabled = false;
      return;
    }
    // Remove
    const rBtn = e.target.closest('.cart-line-remove[data-key]');
    if (rBtn) {
      const key = rBtn.dataset.key;
      try { await changeCartItem(key, 0); await refreshCartUI(); } catch (err) {}
      return;
    }
  });

  // ============ ADD-TO-CART FORMS ============
  document.addEventListener('submit', async function(e) {
    const form = e.target;
    if (!form.matches('form[action*="/cart/add"]')) return;
    e.preventDefault();
    const btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    try {
      const variantId = (form.querySelector('[name="id"]') || {}).value;
      const qty = parseInt((form.querySelector('[name="quantity"]') || {}).value || '1', 10);
      await addToCart(variantId, qty);
      openCart();
    } catch (err) {
      alert(err.message || 'Erro ao adicionar ao carrinho');
    } finally {
      if (btn) btn.disabled = false;
    }
  });

  // ============ ACCORDIONS ============
  document.addEventListener('click', function(e) {
    const head = e.target.closest('.pdp-acc-head, .footer-col-head');
    if (head) {
      head.parentElement.classList.toggle('open');
    }
  });

  // ============ INIT ============
  document.addEventListener('DOMContentLoaded', refreshCartUI);
  if (document.readyState !== 'loading') refreshCartUI();
})();
